import { CommonModule } from "@angular/common";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatIconModule } from "@angular/material/icon";
import { RouterModule, Routes } from "@angular/router";
import { AuthService } from "@core/auth.service";

import { IonicModule } from "@ionic/angular";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";

import { LottieComponent, provideLottieOptions } from "ngx-lottie";
import { ShareButtonsModule } from "ngx-sharebuttons/buttons";
import { ShareIconsModule } from "ngx-sharebuttons/icons";
import { SeeYouSoonComponent } from "src/app/components/see-you-soon/see-you-soon.component";
import { FirestoreTransLoader } from "src/app/services/firestore.service";
import { SwiperModule } from "swiper/angular";
import { DirectiveModule } from "../directives/directive.module";
import { ResetPasswordComponent } from "../pages/account/edit-account/reset-password/reset-password.component";
import { PrizeDrawWinComponent } from "../pages/check-winnings/prize-draw-win/prize-draw-win.component";

import { InAppBrowserService } from "../services/in-app-browser.service";
import { UpdatePopupComponent } from "../update-popup/update-popup.component";
import { AddHomeScreenComponent } from "./add-home-screen/add-home-screen.component";
import { AutoRefreshDialogComponent } from "./auto-refresh-dialog/auto-refresh-dialog.component";
import { BigLotterySpecificComponent } from "./big-lottery-specific/big-lottery-specific.component";
import { CharityExpandComponent } from "./charity-expand/charity-expand.component";
import { CharityPageComponent } from "./charity-page/charity-page.component";
import { ChatbotLiveChatPopComponent } from "./chatbot-live-chat-pop/chatbot-live-chat-pop.component";
import { ChatbotPopupComponent } from "./chatbot-popup/chatbot-popup.component";
import { ChatbotTestComponent } from "./chatbot-test/chatbot-test.component";
import { CountDownTimerComponent } from "./count-down-timer/count-down-timer.component";
import { DeclineSyndicateComponent } from "./decline-syndicate/decline-syndicate.component";
import { DesktopShareComponent } from "./desktop-share/desktop-share.component";
import { DotFlashAnimationComponent } from "./dot-flash-animation/dot-flash-animation.component";
import { DroppingConfettiComponent } from "./dropping-confetti/dropping-confetti.component";
import { EditMobileNumberComponent } from "./edit-mobile-number/edit-mobile-number.component";
import { ExpandableComponent } from "./expandable/expandable.component";
import { FreeWeekConfirmationComponent } from "./free-week-confirmation/free-week-confirmation.component";
import { GamePlayComponent } from "./game-play/game-play.component";
import { HeaderComponent } from "./header/header.component";
import { HelpTestComponent } from "./help-test/help-test.component";
import { CommunitySubtabsComponent } from "./hero-area/community-subtabs/community-subtabs.component";
import { ChangeImagePopupComponent } from "./hero-area/fortune-subtabs/change-image-popup/change-image-popup.component";
import { FortuneDiscoverComponent } from "./hero-area/fortune-subtabs/fortune-discover/fortune-discover.component";
import { FortuneSubtabsComponent } from "./hero-area/fortune-subtabs/fortune-subtabs.component";
import { GamesLeaderboardComponent } from "./hero-area/games-subtabs/games-leaderboard/games-leaderboard.component";
import { GamesSubtabsComponent } from "./hero-area/games-subtabs/games-subtabs.component";
import { InProgressAnimationComponent } from "./in-progress-animation/in-progress-animation.component";
import { InProgressGameAnimationComponent } from "./in-progress-game-animation/in-progress-game-animation.component";
import { InboxMessageComponent } from "./inbox-message/inbox-message.component";
import { InboxMsgFullComponent } from "./inbox-msg-full/inbox-msg-full.component";
import { InboxOptmsgComponent } from "./inbox-optmsg/inbox-optmsg.component";
import { InboxTemplateComponent } from "./inbox-template/inbox-template.component";
import { InformStripComponent } from "./inform-strip/inform-strip.component";
import { Iosa2hsComponent } from "./iosa2hs/iosa2hs.component";
import { JackpotSuccessComponent } from "./jackpot-success/jackpot-success.component";
import { JackpotWarningComponent } from "./jackpot-warning/jackpot-warning.component";
import { LeaveConfirmationComponent } from "./leave-confirmation/leave-confirmation.component";
import { LiveChatComponent } from "./live-chat/live-chat.component";
import { LotterySpecificComponent } from "./lottery-specific/lottery-specific.component";
import { MergeAccountPopupComponent } from "./merge-account-popup/merge-account-popup.component";
import { MySnackbarComponent } from "./my-snackbar/my-snackbar.component";
import { MyToastbarComponent } from "./my-toastbar/my-toastbar.component";
import { MysteryBoxComponent } from "./mystery-box/mystery-box.component";
import { NotificationPopComponent } from "./notification-pop/notification-pop.component";
import { NotificationComponent } from "./notification/notification.component";
import { OnboardingPopupComponent } from "./onboarding-popup/onboarding-popup.component";
import { OngoingWarningComponent } from "./ongoing-warning/ongoing-warning.component";
import { PageNotFoundPageComponent } from "./page-not-found-page/page-not-found-page.component";
import { PasswordTextPage } from "./password-text/password-text.page";
import { AddNewCardComponent } from "./payments/add-new-card/add-new-card.component";
import { AddPaymentComponent } from "./payments/add-payment/add-payment.component";
import { ExistingCardComponent } from "./payments/existing-card/existing-card.component";
import { PayConfirmationComponent } from "./payments/pay-confirmation/pay-confirmation.component";
import { TransactionCompleteComponent } from "./payments/transaction-complete/transaction-complete.component";
import { QuickAccessComponent } from "./quick-access/quick-access.component";
import { RedirectsToSignupComponent } from "./redirects-to-signup/redirects-to-signup.component";
import { ReferFriendComponent } from "./refer-friend/refer-friend.component";
import { ReferralModalComponent } from "./referral-modal/referral-modal.component";
import { RegProfileDialogComponentComponent } from "./reg-profile-dialog-component/reg-profile-dialog-component.component";
import { ResetPasswordPopupComponent } from "./reset-password-popup/reset-password-popup.component";
import { SignupPreventComponent } from "./signup-prevent/signup-prevent.component";
import { SignupSuccessComponent } from "./signup-success/signup-success.component";
import { SocialBenefitsComponent } from "./social-benefits/social-benefits.component";
import { SocialConnectInfoComponent } from "./social-connect-info/social-connect-info.component";
import { StandardPromotionComponent } from "./standard-promotion/standard-promotion.component";
import { StoreTopUpComponent } from "./store-top-up/store-top-up.component";
import { SugerDropComponent } from "./suger-drop/suger-drop.component";
import { SyndicateMemberPopupComponent } from "./syndicate-member-popup/syndicate-member-popup.component";
import { SyndicateSummaryComponent } from "./syndicate-summary/syndicate-summary.component";
import { TermsAndConditionPage } from "./terms-and-condition/terms-and-condition.page";
import { TermsAndPolicyComponent } from "./terms-and-policy/terms-and-policy.component";
import { TesterEventsComponent } from "./tester-events/tester-events.component";
import { TopHeaderComponent } from "./top-header/top-header.component";
import { TopNotificationComponent } from "./top-notification/top-notification.component";
import { VerifyPhoneNumberComponent } from "./verify-phone-number/verify-phone-number.component";
import { VoucherDialogComponent } from "./voucher-dialog/voucher-dialog.component";
import { WhatsOnDetailComponent } from "./whats-on-detail/whats-on-detail.component";
import { WhatsOnPage } from "./whats-on/whats-on.page";
import { WindowsGamePlayPopupComponent } from "./windows-game-play-popup/windows-game-play-popup.component";
// import new component to display feed animation
import { LevelUpFeedAnimationComponent } from "./level-up-feed-animation/level-up-feed-animation.component";
// import new component to display narrator tips animation
import player from 'lottie-web';
import { PaymentHolidayComponent } from "../pages/syndicate/payment-holiday/payment-holiday.component";
import { AchievementCelebrationComponent } from "./achievement-celebration/achievement-celebration.component";
import { RequestConfirmationComponent } from "./add-home-screen/request-confirmation/request-confirmation.component";
import { ApiLoaderComponent } from "./api-loader/api-loader.component";
import { AutoClickButtonComponent } from "./auto-click-button/auto-click-button.component";
import { CheckoutConfirmationComponent } from "./checkout-confirmation/checkout-confirmation.component";
import { CustomAddCardComponent } from "./custom-add-card/custom-add-card.component";
import { FortuneMissionsPopupComponent } from "./fortune-missions-popup/fortune-missions-popup/fortune-missions-popup.component";
import { FortuneLifestyleComponent } from "./hero-area/fortune-subtabs/fortune-lifestyle/fortune-lifestyle.component";
import { FortuneMissionsComponent } from "./hero-area/fortune-subtabs/fortune-missions/fortune-missions/fortune-missions.component";
import { JoinPoupComponent } from "./hero-area/games-subtabs/join-poup/join-poup/join-poup.component";
import { SocialGamePreviewComponent } from "./hero-area/games-subtabs/social-game-preview/social-game-preview.component";
import { NarratorTipsComponent } from "./narrator-tips/narrator-tips.component";
import { NewCountDownTimerComponent } from "./new-count-down-timer/new-count-down-timer.component";
import { OwnedPhotoPopupComponent } from "./owned-photo-popup/owned-photo-popup.component";
import { PausedSyndicateComponent } from "./paused-syndicate-popup/paused-syndicate-popup.component";
import { PermanentlyCloseComponent } from "./permanently-close-popup/permanently-close-popup.component";
import { PrizeBoxComponent } from "./prize-box/prize-box.component";
import { ProsubPageComponent } from "./prosub-page/prosub-page.component";
import { PushNotificationBannerComponent } from "./push-notification-banner/push-notification-banner.component";
import { SovendusPageComponent } from "./sovendus-page/sovendus-page.component";
import { SuggestionComponent } from "./suggestion/suggestion.component";
import { SwitchExpressModalComponent } from "./switch-express-modal/switch-express-modal.component";
import { SyndicateLoadingComponent } from "./syndicate-loading/syndicate-loading.component";
import { TakeoverPageComponent } from "./takeover-page/takeover-page.component";
import { TutorialPopupComponent } from "./tutorial-popup/tutorial-popup.component";
import { UnsplashPhotoPopupComponent } from "./unsplash-photo-popup/unsplash-photo-popup.component";
import { WinMorePopupComponent } from "./win-more-popup/win-more-popup.component";
import { WinMorePromisePopupComponent } from "./win-more-promise-popup/win-more-promise-popup.component";
import { WinMoreEndinboxComponent } from "./winmore-popup-endinbox/winmore-popup-endinbox.component";
import { WinMoreStartinboxComponent } from "./winmore-popup-startinbox/winmore-popup-startinbox.component";
import { QRCodeComponent } from "angularx-qrcode";
export function FirestoreTranslationsLoaderFactory(http: HttpClient, authService: AuthService) {
  return new FirestoreTransLoader(http);
}

const routes: Routes = [
  {
    path: "addPayment",
    component: AddPaymentComponent,
  },
  {
    path: "paymentConfirmation",
    component: PayConfirmationComponent,
  },
];

@NgModule({
  exports: [
    AutoClickButtonComponent,
    InProgressAnimationComponent,
    ExpandableComponent,
    ExistingCardComponent,
    AddNewCardComponent,
    TransactionCompleteComponent,
    InProgressGameAnimationComponent,
    WhatsOnDetailComponent,
    AddPaymentComponent,
    HeaderComponent,
    TopHeaderComponent,
    DroppingConfettiComponent,
    CountDownTimerComponent,
    NotificationComponent,
    DotFlashAnimationComponent,
    PageNotFoundPageComponent,
    ChatbotPopupComponent,
    WindowsGamePlayPopupComponent,
    InboxMsgFullComponent,
    OnboardingPopupComponent,
    NotificationPopComponent,
    TopNotificationComponent,
    BigLotterySpecificComponent,
    SugerDropComponent,
    LotterySpecificComponent,
    StandardPromotionComponent,
    InformStripComponent,
    CharityExpandComponent,
    CharityPageComponent,
    OngoingWarningComponent,
    JackpotWarningComponent,
    PrizeDrawWinComponent,
    SocialBenefitsComponent,
    MysteryBoxComponent,
    CommunitySubtabsComponent,
    FortuneSubtabsComponent,
    GamesSubtabsComponent,
    HelpTestComponent,
    ChatbotTestComponent,
    GamesLeaderboardComponent,
    AchievementCelebrationComponent,
    NewCountDownTimerComponent,
    PaymentHolidayComponent,
    CheckoutConfirmationComponent,
    SovendusPageComponent,
    PushNotificationBannerComponent,
    SuggestionComponent,
  ],
  imports: [
    CommonModule,
    IonicModule,
    RouterModule.forChild(routes),
    FormsModule,
    ReactiveFormsModule,
    DirectiveModule,
    MatIconModule,
    HttpClientModule,
    SwiperModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: FirestoreTranslationsLoaderFactory,
        deps: [HttpClient, AuthService],
      },
      defaultLanguage: "en",
    }),
    QRCodeComponent,
    ShareIconsModule,
    ShareButtonsModule.withConfig({
      debug: true,
    }),
    LottieComponent,
    PausedSyndicateComponent,
    InProgressAnimationComponent,
    ChatbotLiveChatPopComponent,
    MergeAccountPopupComponent,
    ReferralModalComponent,
    ExpandableComponent,
    ExistingCardComponent,
    AddNewCardComponent,
    TransactionCompleteComponent,
    InProgressGameAnimationComponent,
    MySnackbarComponent,
    MyToastbarComponent,
    Iosa2hsComponent,
    WhatsOnDetailComponent,
    InboxMessageComponent,
    InboxTemplateComponent,
    AddPaymentComponent,
    StoreTopUpComponent,
    HeaderComponent,
    TopHeaderComponent,
    DroppingConfettiComponent,
    CountDownTimerComponent,
    NotificationComponent,
    PayConfirmationComponent,
    VerifyPhoneNumberComponent,
    ReferFriendComponent,
    WhatsOnPage,
    TermsAndConditionPage,
    PasswordTextPage,
    SyndicateMemberPopupComponent,
    TermsAndPolicyComponent,
    ResetPasswordComponent,
    VoucherDialogComponent,
    SyndicateSummaryComponent,
    SignupSuccessComponent,
    ResetPasswordPopupComponent,
    EditMobileNumberComponent,
    DeclineSyndicateComponent,
    LeaveConfirmationComponent,
    AddHomeScreenComponent,
    QuickAccessComponent,
    FreeWeekConfirmationComponent,
    UpdatePopupComponent,
    DotFlashAnimationComponent,
    RedirectsToSignupComponent,
    GamePlayComponent,
    SeeYouSoonComponent,
    JackpotSuccessComponent,
    PageNotFoundPageComponent,
    LiveChatComponent,
    TesterEventsComponent,
    SocialConnectInfoComponent,
    ChatbotPopupComponent,
    WindowsGamePlayPopupComponent,
    InboxMsgFullComponent,
    OnboardingPopupComponent,
    RegProfileDialogComponentComponent,
    NotificationPopComponent,
    TopNotificationComponent,
    BigLotterySpecificComponent,
    SugerDropComponent,
    LotterySpecificComponent,
    StandardPromotionComponent,
    InformStripComponent,
    CharityExpandComponent,
    CharityPageComponent,
    OngoingWarningComponent,
    JackpotWarningComponent,
    PrizeDrawWinComponent,
    AutoRefreshDialogComponent,
    SocialBenefitsComponent,
    MysteryBoxComponent,
    CommunitySubtabsComponent,
    FortuneSubtabsComponent,
    GamesSubtabsComponent,
    InboxOptmsgComponent,
    SignupPreventComponent,
    DesktopShareComponent,
    HelpTestComponent,
    ChatbotTestComponent,
    FortuneDiscoverComponent,
    ChangeImagePopupComponent,
    GamesLeaderboardComponent,
    LevelUpFeedAnimationComponent,
    NarratorTipsComponent,
    SocialGamePreviewComponent,
    ProsubPageComponent,
    TutorialPopupComponent,
    FortuneLifestyleComponent,
    OwnedPhotoPopupComponent,
    UnsplashPhotoPopupComponent,
    AchievementCelebrationComponent,
    FortuneMissionsComponent,
    FortuneMissionsPopupComponent,
    JoinPoupComponent,
    TakeoverPageComponent,
    NewCountDownTimerComponent,
    SyndicateLoadingComponent,
    RequestConfirmationComponent,
    PermanentlyCloseComponent,
    CustomAddCardComponent,
    WinMorePopupComponent,
    WinMorePromisePopupComponent,
    WinMoreStartinboxComponent,
    WinMoreEndinboxComponent,
    PaymentHolidayComponent,
    SwitchExpressModalComponent,
    PrizeBoxComponent,
    ApiLoaderComponent,
    AutoClickButtonComponent,
    CheckoutConfirmationComponent,
    SovendusPageComponent,
    PushNotificationBannerComponent,
    SuggestionComponent,
  ],
  providers: [
    InAppBrowserService,
    provideLottieOptions({
      player: () => player,
    }),
  ],
})
export class ComponentModule { }
